import Sidebar from './components/Sidebar'
import React, { Suspense, Fragment, useLayoutEffect } from 'react'
import { Outlet, useLocation, useNavigate, useParams } from 'react-router-dom'

import CampaignNav from './components/campaignNav'
import { MediaBuyingProvider, useMediaBuyingContext } from '../context/media-buying-context'
import { isEmpty } from '../utils/tools'
import { ToastContainer } from 'react-toastify'
import { showNotification } from '../utils/notifications'
import { CubeLoader } from '@/components/ui'

export function MediaBuyLayout() {
    return (
        <MediaBuyingProvider>
            <MediaBuyInner />
        </MediaBuyingProvider>
    )
}

function MediaBuyInner() {
    const { id } = useParams()
    const { pathname } = useLocation()
    const navigate = useNavigate()
    const { adAccounts, connectedPublishers, loading, error } = useMediaBuyingContext()

    useLayoutEffect(() => {
        const [section, subSection] = pathname.split('/').filter(Boolean).slice(-2)
        if (section !== 'settings' || subSection !== 'ad-account') {
            if (isEmpty(connectedPublishers) && !loading) {
                showNotification(
                    `A connected Ad Account is needed for Media Buying. 
                        Please connect an Ad Account to continue.`,
                    'error',
                )
                navigate(`/campaigns/media-buying/${id}/settings/ad-account`, { replace: true })
            }
        }
    }, [id, pathname, adAccounts, connectedPublishers, loading])
    const theme = localStorage.getItem('theme') || 'light'

    return (
        <Fragment>
            <ToastContainer />
            <Sidebar appName={import.meta.env.VITE_NAME} />
            <main className={`main-content position-relative campaign-nav campaign-nav-${theme} d-flex`}>
                <CampaignNav campaignId={id} />
                <Suspense fallback={<CubeLoader size="default" fullScreen={false} />}>
                    <div
                        className="d-flex position-relative container-fluid content-inner background-gray-blue p-4"
                        style={theme === 'light' ? { backgroundColor: 'white' } : {}}
                    >
                        <div
                            className={`${theme === 'light' ? 'card-shadow' : 'mediabuy-card'} flex-fill`}
                            style={{ borderRadius: '4px' }}
                        >
                            <Outlet />
                        </div>
                    </div>
                </Suspense>
            </main>
        </Fragment>
    )
}
